export default __webpack_public_path__ + "static/media/p12.d5ea312f.jpg";